<div class="status">
  @if (status() === "pending") {
    <iw-dot-pulse />
  } @else {
    <fu-icon [iconName]="iconName() ?? status()" [size]="iconSize()" />
  }
</div>

<ng-content select="[beforeTitle]"></ng-content>

<h4 class="title">
  {{ title() }}
</h4>

<ng-content select="[afterTitle]"></ng-content>
